<template>
    <countdown :end-time="endTime" id="sticky-countdown" class="is-countdown">
        <template
            v-slot:process="{ timeObj }">
            <div id="sticky-countdown" class="is-countdown"><span class="countdown-row countdown-show4"><span
                class="countdown-section"><span class="countdown-amount">{{ timeObj.d }}</span><span
                class="countdown-period">{{ __('Nap') }}</span></span><span
                class="countdown-section"><span class="countdown-amount">{{ timeObj.h }}</span><span
                class="countdown-period">{{ __('Óra') }}</span></span><span class="countdown-section"><span
                class="countdown-amount">{{ timeObj.m }}</span><span class="countdown-period">{{ __('Perc')}}</span></span><span
                class="countdown-section"><span class="countdown-amount">{{ timeObj.s }}</span><span
                class="countdown-period">{{ __('Másodperc')}}</span></span></span></div>
        </template>
    </countdown>
</template>

<script>
import vueAwesomeCountdown from 'vue-awesome-countdown'

export default {
    name: 'BudmilCountdown',

    components: {
        vueAwesomeCountdown
    },

    props: {
        endTime: {
            required: true
        }
    }
}
</script>

<style scoped>

</style>
